import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";
import { loadDashboard, stopTimer, AuthenticatedUser } from "../api"
import DBAccountInfo from "./pageParts/dbAccountInfo";
import DBDownloads from "./pageParts/dbDownloads";
import DBOrders from "./pageParts/dbOrders";
import DBLandingPages from "./pageParts/dbLandingPages";
import StickyBox from "react-sticky-box";
import queryString from "query-string";
import ModalWindow from '../common/modalWindow'

class Dashboard extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        const value = queryString.parse(this.props.location.search);

        this.state = {
            loading: true,
            openId: value.oid,
            open: value.oid ? true : false,
            error: '',
            data: {},
            pid: value.uid ? value.uid : user ? user._id : 0,
            operation: params.operation?params.operation:'account',
        }
    }

    getPid() {
        const { user } = AuthenticatedUser();
        const value = queryString.parse(this.props.location.search);
        return value.uid ? value.uid : user ? user._id : 0
    }

    openFilter = () => {
        document.querySelector(".collection-filter").style = "left: -15px";
    }
    closeFilter = () => {
        document.querySelector(".collection-filter").style = "left: -365px";
    }

    onCancel = () => {
        this.setState({open: false});
    };

    onOperationClick(e, operation) {
        e.preventDefault();
        this.setState({operation});
        return false;
    }

    loadDashboard = () => {
        const pid = this.getPid();
        if (pid) {
            loadDashboard(pid).then(d2 => {
                if (d2 && d2.error) {
                    this.setState( {error: d2.error, loading: false});
                } else {
                    if (!d2.primeMembership) {
                        d2.primeMembership = {
                            active: false,
                            renewalDate: null,
                            autoRenew: false
                        }
                    }
                              
                    if (!d2.preferences) {                  
                        d2.preferences = {
                            darktheme: false,
                            notificationsNewPost: true,
                            notificationsNewProduct: true, 
                            notificationsNewResource: true, 
                            notificationsNewNewsletter: true, 
                            notificationsNewAnnouncement: true, 
                            notificationsNewComment: true
                        }
                    }

                    this.setState({ data: d2, pid: pid, loading: false});      
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadDashboard();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.location.search !== this.props.location.search) {
            this.loadDashboard();
        }

        if(prevProps.match.params.operation !== this.props.match.params.operation) {
            this.setState({operation: this.props.match.params.operation});
        }
    }

    render(){
        const { data, operation, pid } = this.state;

        if (this.state.loading) { return null; }
        else { 
            stopTimer();
            return (
                <div>
                    <Breadcrumb title={'Dashboard'}/>
                    
                    
                    {/*Dashboard section*/}
                    <section className="section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9">                            
                                    {operation === 'account' && pid !== 0 && <DBAccountInfo item={data} />}
                                    {operation === 'orders' && pid !== 0 && <DBOrders item={data} />}
                                    {operation === 'downloads' && pid !== 0 && <DBDownloads item={data} />}
                                    {operation === 'pages' && pid !== 0 && <DBLandingPages item={data} />}

                                </div>

                                {/*Side Panel*/}
                                <div className="col-sm-3 collection-filter ">                                                             
                                    <StickyBox offsetTop={200} offsetBottom={20}>
                                        <div className="collection-filter-block ">
                                            <div className="collection-mobile-back ">
                                                <span className="filter-back" onClick={(e) => this.closeFilter(e)} >
                                                    <i className="fa fa-angle-left" aria-hidden="true"></i> back
                                                </span>
                                            </div>
                                            <div className="block-content">                                    
                                                <ul>
                                                    <li className={operation === 'account' ? 'active':''}><a href='/pages/dashboard/account' onClick={(e) => this.onOperationClick(e, 'account')} >Account Info</a></li>
                                                    <li className={operation === 'orders' ? 'active':''}><a href="/pages/dashboard/orders" onClick={(e) => this.onOperationClick(e, 'orders')} >My Orders</a></li>
                                                    <li className={operation === 'downloads' ? 'active':''}><a href="/pages/dashboard/downloads" onClick={(e) => this.onOperationClick(e, 'downloads')} >My Downloads</a></li>
                                                    <li className={operation === 'pages' ? 'active':''}><a href="/pages/dashboard/pages" onClick={(e) => this.onOperationClick(e, 'pages')} >My Landing Pages</a></li>
                                                    <li className="last"><a href="/pages/login">Log Out</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </StickyBox>
                                </div>
                                
                            </div>
                        </div>
                    </section>
                    {this.state.openId === "1" && 
                        <ModalWindow title="Subscriptions" open={this.state.open} onCancel={this.onCancel}
                            content="Please use the Notification area to configure your subscription"
                            commands={[
                                {title: "Ok", handler: this.onCancel}
                            ]}
                        />
                    }
                </div>
            )
        }
    }
}

export default Dashboard